import {
  uploadInitialized, uploadSuccess,
  uploadFile, uploadProgress,
  uploadError,
} from '../actions/file';
import {POST} from '../helpers/request';

export const FILE_UPLOAD = 'File upload';
export const ABORT_UPLOAD = 'Abort upload';

const chunkSize = 2e6;

const uploads = {};

const sliceFunction =
  File.prototype.webkitSlice ||
  File.prototype.mozSlice ||
  File.prototype.slice;

const slice = (file, ...args) =>
  sliceFunction.call(file, ...args);

const checkAborted = (tempId, store) => {
  if (!uploads[tempId] || uploads[tempId].aborted) {
    delete uploads[tempId];
    return true;
  }

  return false;
};

const initializeUpload = async (tempId, file, store, successAction) => {
  if (checkAborted(tempId, store)) {
    return;
  }

  try {
    const {name: fileName, size: fileSize} = file;
    const {id} = await POST({
      endpoint: '/files',
      body: {fileName, fileSize},
    }, store.dispatch);

    if (checkAborted(tempId, store)) {
      return;
    }

    store.dispatch(uploadInitialized(tempId, id));

    let completedBytes = 0;
    let lastProgress = 0;
    const chunkCount = Math.max(Math.ceil(fileSize / chunkSize), 1);
    for (let i = 0; i < chunkCount; i++) {
      const isLastChunk = i === chunkCount - 1;
      const start = i * chunkSize;
      const end = Math.min(fileSize, start + chunkSize);
      const blob = slice(file, start, end);

      const body = new FormData();
      body.append('file', blob);
      const metadata = await POST({
        endpoint: `/files/${id}`,
        body,
        expectBody: isLastChunk,
      });

      if (checkAborted(tempId, store)) {
        return;
      }

      completedBytes += blob.size;
      const progress = Math.floor((completedBytes / fileSize) * 100);
      if (isLastChunk) {
        store.dispatch(uploadSuccess(tempId, metadata));
        if (successAction) {
          store.dispatch(successAction(tempId, metadata));
        }
      } else if (lastProgress !== progress) {
        store.dispatch(uploadProgress(tempId, progress));
      }
      lastProgress = progress;
    }
  } catch (err) {
    if (!checkAborted(tempId, store)) {
      store.dispatch(uploadError(tempId, err));
    }
  }
};

export default store => next => action => {
  const result = next(action);
  const {tempId} = action;
  if (!tempId) {
    return result;
  }

  let file = action[FILE_UPLOAD];
  if (file) {
    uploads[tempId] = {
      aborted: false,
    };
    let successAction = null;
    if (file.success) {
      successAction = file.success;
      file = file.file;
    }
    store.dispatch(uploadFile(tempId, file));
    setTimeout(() => initializeUpload(tempId, file, store, successAction));
  }
  if (action[ABORT_UPLOAD]) {
    const upload = uploads[action.tempId];
    if (upload) {
      upload.aborted = true;
    }
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/middleware/fileUploader.js